export const RELATORIO_JOB_TIPO = {
  AUDITORIA_FAIXA: 'AUDITORIA_FAIXA',
  PARSE_RFG_AUDITORIA_FAIXA: 'PARSE_RFG_AUDITORIA_FAIXA',
};

export const RELATORIO_JOB_STATUS = {
  CREATED: 'CREATED',
  PROCESSING: 'PROCESSING',
  AVAILABLE: 'AVAILABLE',
  ERROR: 'ERROR',
};

export const RELATORIO_JOB_MENU_SIZE = 8;
export const RELATORIO_JOB_PAGE_SIZE = 20;
export const RELATORIO_JOB_POLL_MS = 2500;

export const isRelatorioJobInFlight = (status) =>
  status === RELATORIO_JOB_STATUS.CREATED || status === RELATORIO_JOB_STATUS.PROCESSING;

export const isRelatorioJobAvailable = (status) =>
  status === RELATORIO_JOB_STATUS.AVAILABLE;

export const isParseRfgJob = (job) =>
  job && job.tipo === RELATORIO_JOB_TIPO.PARSE_RFG_AUDITORIA_FAIXA;

export const isDownloadableRelatorioJob = (job) => job && !isParseRfgJob(job);

export const filterDownloadableRelatorioJobs = (items = []) =>
  items.filter(isDownloadableRelatorioJob);

const buildTitulo = (raw = {}) => {
  if (raw.titulo) return raw.titulo;
  if (raw.tipo === RELATORIO_JOB_TIPO.PARSE_RFG_AUDITORIA_FAIXA) {
    return raw.nsirCodigo ? `Parse RFG ${raw.nsirCodigo}` : 'Parse RFG';
  }
  if (raw.tipo === RELATORIO_JOB_TIPO.AUDITORIA_FAIXA || !raw.tipo) {
    return raw.nsirCodigo ? `Auditoria de Faixa ${raw.nsirCodigo}` : 'Auditoria de Faixa';
  }
  return raw.tipo;
};

export const normalizeRelatorioJob = (raw = {}) => ({
  id: raw.id,
  tipo: raw.tipo || RELATORIO_JOB_TIPO.AUDITORIA_FAIXA,
  entityId: raw.entityId || raw.nsirId || null,
  nsirId: raw.nsirId || raw.entityId || null,
  status: raw.status,
  error: raw.error || null,
  titulo: buildTitulo(raw),
  nomeArquivo: raw.nomeArquivo || raw.nome || (raw.arquivo && raw.arquivo.nome) || null,
  url: raw.url || raw.arquivoUrl || (raw.arquivo && raw.arquivo.url) || null,
  dataCriacao: raw.dataCriacao || null,
  dataAtualizacao: raw.dataAtualizacao || null,
});

export const normalizeParseRfgJob = (raw = {}, nsirId) =>
  normalizeRelatorioJob({
    ...raw,
    tipo: RELATORIO_JOB_TIPO.PARSE_RFG_AUDITORIA_FAIXA,
    entityId: raw.entityId || raw.nsirId || nsirId,
    nsirId: raw.nsirId || nsirId,
  });

export const parseRelatorioJobsPage = (body) => {
  if (!body) return { items: [], totalElements: 0 };
  if (Array.isArray(body)) {
    const items = body.map(normalizeRelatorioJob);
    return { items, totalElements: items.length };
  }
  const list = body.content || body.rows || [];
  const items = (Array.isArray(list) ? list : []).map(normalizeRelatorioJob);
  const totalElements = body.totalElements ?? body.totalRows ?? items.length;
  return { items, totalElements };
};

export const getRelatorioStatusPath = (job) => {
  if (!job || !job.id) return null;
  if (isParseRfgJob(job)) return null;
  const tipo = job.tipo || RELATORIO_JOB_TIPO.AUDITORIA_FAIXA;
  if (tipo === RELATORIO_JOB_TIPO.AUDITORIA_FAIXA) {
    return `reports/auditoria-faixa/${job.id}`;
  }
  return null;
};

export const getRelatorioDocumentoPath = (job) => {
  if (!job || !job.id) return null;
  if (isParseRfgJob(job)) return null;
  const tipo = job.tipo || RELATORIO_JOB_TIPO.AUDITORIA_FAIXA;
  if (tipo === RELATORIO_JOB_TIPO.AUDITORIA_FAIXA) {
    return `reports/auditoria-faixa/${job.id}/documento`;
  }
  return null;
};

export const getParseRfgJobsUrl = ({ nsirId, size = 20 } = {}) => {
  const params = [
    `tipo=${RELATORIO_JOB_TIPO.PARSE_RFG_AUDITORIA_FAIXA}`,
    'p=0',
    `s=${size}`,
  ];
  if (nsirId) params.push(`entityId=${encodeURIComponent(nsirId)}`);
  return `reports/jobs?${params.join('&')}`;
};

export const pickParseRfgJob = (items = [], { jobId, nsirId } = {}) => {
  const parseList = (items || []).filter(isParseRfgJob);
  const scoped = nsirId
    ? parseList.filter((job) => (job.entityId || job.nsirId) === nsirId)
    : [];
  if (!nsirId) return null;
  if (jobId) {
    const byId = scoped.find((job) => job.id === jobId);
    if (byId) return byId;
  }
  return scoped[0] || null;
};

export const getJobSubtitle = (job) => {
  if (!job) return '';
  if (isParseRfgJob(job)) {
    if (isRelatorioJobInFlight(job.status)) return 'Processando o RFG…';
    if (job.status === RELATORIO_JOB_STATUS.ERROR) {
      return job.error || 'Falha ao processar o RFG. A NSIR não fica bloqueada — cadastre os serviços manualmente.';
    }
    if (isRelatorioJobAvailable(job.status)) return 'Serviços pré-criados a partir do RFG';
    return job.nomeArquivo || '';
  }
  if (isRelatorioJobInFlight(job.status)) return 'Gerando documento…';
  if (job.status === RELATORIO_JOB_STATUS.ERROR) return job.error || 'Falha ao gerar o relatório';
  return job.nomeArquivo || 'Pronto para baixar';
};
